import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Tools" }

import WidthSlider from "@/components/tools/WidthSlider.vue";
import ThresholdSlider from "@/components/tools/ThresholdSlider.vue";
import GridSlider from "@/components/tools/GridSlider.vue";
import DrawSwitch from "@/components/tools/DrawSwitch.vue";
import WinnerTakesAllSwitch from "@/components/tools/WinnerTakesAllSwitch.vue";
import { useMainStore } from "@/stores/main";


export default /*@__PURE__*/_defineComponent({
  __name: 'Tools',
  setup(__props) {

const store = useMainStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GridSlider),
    _createVNode(ThresholdSlider),
    (_unref(store).measured)
      ? (_openBlock(), _createBlock(WidthSlider, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(DrawSwitch),
    _createVNode(WinnerTakesAllSwitch)
  ]))
}
}

})